// extracted by mini-css-extract-plugin
module.exports = {"label":"TextInput_label__iTAid","input":"TextInput_input__sd6Bn","span":"TextInput_span__MstHr","is_active":"TextInput_is_active__s3oQe"};